<template lang="jade">
  div.Lightbox.Lightbox--open(v-if="(loading && config.loadingAnimation)"
                              class="animated"
                              transition="fade")
    spinner(":loading.sync"="loading")
  div.Fragment(":skin"="skins.app" ":id"="wid | format")
    template(v-if="requestError.msg && !workflowSet.body")
      div(class="Message Message--info" 
          ":skin"="skins.messages")
        i(class="fa fa-info" 
          style="margin-right: 15px")
        span(class="Message__body") {{ requestError.msg }}
    template(v-if="workflowSet.header")
      wf-header(":content"="worklowSet.header")
    template(v-if="workflowSet.body")
      wf-body(":workflow"="workflowSet.body[0]")
    template(v-if="workflowSet.footer")
      wf-footer(":content"="worklowSet.footer")
  notifications
</template>

<script>
import body from './workflow'
import header from './partials/header'
import footer from './partials/footer'
import dialogs from 'src/components/dialogs/index'
import spinner from 'src/components/loaders/spinner'
import { Workflows, Auth } from 'src/services/resources'
import {
  addNotification,
  mergeConfig
} from 'src/vuex/actions.js'
import {skins,
        config} from 'src/vuex/getters.js'

export default {
  data () {
    return { uid: null,
             fingerprint: null,
             loading: false,
             prompt: false,
             requestError: {},
             workflowSet: {},
             loginSchema: require('src/components/forms/_data/login.json') }
  },

  props: {
    wid: {
      type: String,
      required: true
    },
    sid: {
      type: String,
      default: 'Member'
    },
    opts: {
      type: Object,
      default: {}
    },
    params: {
      type: Object,
      default: () => ({})
    },
    dynamic: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headers () {
      // refactor for vuex workflow header
      return { headers: { 'X-SITEID': this.sid } }
    }
  },
  filters: {
    format (x) {
      return x.toLowerCase().split('.').join('-')
    }
  },
  components: {
    'wf-header': header,
    'wf-body': body,
    'wf-footer': footer,
    spinner,
    notifications: dialogs.notifications
  },

  methods: {
    fetchExisting (nw) {
      this.$set('loading', true)
      Workflows.get(nw.wid, nw.params, nw.headers)
        .then(this.success)
        .catch(this.fail)
    },

    fetch (wid, params) {
      this.$set('loading', true)
      if (this.dynamic) {
        this.$dispatch('state::loading', false)
      }
      Workflows.get(wid, params, this.headers)
        .then(this.success)
        .catch(this.fail)
    },

    success (res) {
      this.$set('workflowSet', res.data.content)
      this.$set('fingerprint', res.data.fingerprint)
      setTimeout(() => {
        this.$set('loading', false)
      }, 900)
    },

    fail (res) {
      switch (res.status) {
        case 400:
          this.notice('error', res.data.user_message)
          break
        case 500:
          let msg = conf && _.has(conf, 'error') ? conf.error : 'Internal error'
          this.$set('requestError.msg', msg)
          break
        default:
          // this.login()
          // dispatch to auth component
      }
      this.$set('loading', false)
    },

    notice (type, msg) {
      this.addNotification({
        type: type,
        msg: [msg],
        id: 22,
        onComplete: 'remove',
        show: true
      })
    },

    login () {
      this.prompt = true
    },

    authenticate (credentials) {
      Auth.login(credentials, this.headers)
        .then(response => {
          this.fetch()
          this.$set('prompt', false)
        })
        .catch(this.fail)
    }
  },

  vuex: {
    getters: {
      skins,
      config
    },
    actions: {
      addNotification,
      mergeConfig
    }
  },
  beforeCompile () {
    this.mergeConfig(this.opts)
  },
  created () {
    let params = _.split(location.search.replace('?', ''), '&').reduce((res, xs) => {
      let [k, v] = xs.split('=')
      return _.set(res, k, v)
    }, {})

    if (_.has(params, 'nw')) {
      let key = 'new::window' + params.nw
      this.fetchExisting(JSON.parse(localStorage.getItem(key)))
      // localStorage.removeItem(key)
    } else {
      this.fetch(this.wid, this.params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// set.vue?78ba855e